<div class="container mt-2 mb-0" #ccContainer>
  <div class="row justify-content-center my-4">
    <div class="col-12 col-md-8">
      <div class="row rounded pb-3">

        @if(loading()) {
          <mat-progress-spinner
            color="primary"
            mode="indeterminate"
          >
          </mat-progress-spinner>
        }
        @else {
          @if(cartError()) {
            <div class="error-section">Error: {{cartError()}}</div>
          }    
          @if(cartCompleted()) {
            <div>This cart is already paid</div>
          }
          @if(!cartError() && !cartCompleted()) {
            <equine-ui-nx-order-summary
              [subtotal]="subTotal()"
              [subtotalCount]="totalItems()"
              [coupon]="coupon()"
              [donation]="donationOrderTotal()"
              [total]="total()"
              (goBack)="goBack()"
            ></equine-ui-nx-order-summary>
          }
        }
      </div>
    </div>

    <div class="col-12 col-md-4">
      <mat-card class="p-0 shadow">
        <mat-card-header>
          <mat-card-title class="card-title">Proceed to Payment</mat-card-title>
        </mat-card-header>
        <hr>

        <div>
          <div class="mx-4">Please select an option:</div>
          <mat-radio-group aria-label="Select an option" class="radio-group mx-4"
              [(ngModel)]="paymentTypeSelected"
              [disabled]="paying()"
              (change)="onRadioGroupChange($event)"
            >
              <mat-radio-button value="savedCard">
                Use your saved cards
              </mat-radio-button>
              <mat-radio-button value="manualCard">
                Use new credit card
              </mat-radio-button>
            </mat-radio-group>
        </div>

        <div [ngClass]="{hide: this.optionSelected!=='savedCard'}" class="m-3">
          <div class="panel">
            <header class="panel__header">
              <div class="header-text">Saved cards</div>
            </header>
  
            <equine-ui-nx-bt-credit-card-selector
              [creditCards]="creditCards"
              (tokenSelected)="onTokenSelected($event)"
            >
            </equine-ui-nx-bt-credit-card-selector>

            <footer class="panel__footer">
              <button mat-raised-button value="Pay" (click)="payWithSavedCard();" class="pay-button" [disabled]="!creditCardToken || paying()">Pay with saved card</button>
            </footer>
          </div>
        </div>

        <div class="row justify-content-center my-4"  [ngClass]="{hide: this.optionSelected!=='manualCard'}">
          <div class="col-md-11">
            <form id="cardForm">
              <div class="panel">
                <header class="panel__header">
                  <div class="header-text">New credit card</div>
                </header>
                <div class="panel__content">
                  <div class="textfield--float-label">
                    <!-- Begin hosted fields section -->
                    <label class="hosted-field--label" for="card-number" id="card-number-label">
                      <mat-icon aria-hidden="false" aria-label="credit-card-number" fontIcon="credit_card" class="icon-small"></mat-icon>                     
                      <span>Card Number</span>
                    </label>
                    <div id="card-number" class="hosted-field"></div>
                    <!-- End hosted fields section -->
                  </div>

                  <div class="textfield--float-label">
                    <!-- Begin hosted fields section -->
                    <label class="hosted-field--label" for="expiration-date" id="expiration-date-label">
                      <mat-icon aria-hidden="false" aria-label="card holder name" fontIcon="event" class="icon-small"></mat-icon>                     
                      <span>Expiration Date</span>
                    </label>
                    <div id="expiration-date" class="hosted-field"></div>
                    <!-- End hosted fields section -->
                  </div>

                  <div class="textfield--float-label">
                    <!-- Begin hosted fields section -->
                    <label class="hosted-field--label" for="cvv" id="cvv-label">
                      <mat-icon aria-hidden="false" aria-label="card holder name" fontIcon="pin" class="icon-small"></mat-icon>                     
                      <span>CVV</span>
                    </label>
                    <div id="cvv" class="hosted-field"></div>
                    <!-- End hosted fields section -->
                  </div>

                  <div class="textfield--float-label">
                    <label class="hosted-field--label" for="card-holder-name" id="card-holder-name-label">
                      <mat-icon aria-hidden="false" aria-label="card holder name" fontIcon="person" class="icon-small"></mat-icon>                     
                      <span>Cardholder's Name</span>
                    </label>
                    <div id="card-holder-name" class="hosted-field"></div>
                  </div>

                  <div class="textfield--float-label">
                    <label class="hosted-field--label" for="zip-code" id="zip-code-label">
                      <mat-icon aria-hidden="false" aria-label="card holder name" fontIcon="person" class="icon-small"></mat-icon>                     
                      <span>Zip code</span>
                    </label>
                    <div id="zip-code" class="hosted-field"></div>
                  </div>
                  
                  <div>
                    <div class="hosted-field--label">Do you want to save this card for future payments?</div>
                    <mat-checkbox class="" [(ngModel)]="vaultCard" [ngModelOptions]="{standalone: true}">Yes</mat-checkbox>
                  </div>


                </div>
                <footer class="panel__footer">
                  <button mat-raised-button value="Pay" (click)="tokenizeUserDetails();" class="pay-button" [disabled]="disablePayButton() || paying()">Pay</button>
                </footer>
              </div>
            
            </form>
          </div>
        </div>

      </mat-card>
    </div>
  </div>

</div>